import styled from "styled-components";

/**
 * Wrapper principal do filtro de intervalo de preços.
 */
export const RangeFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

/**
 * Wrapper do título.
 */
export const TitleWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing(2.5)};
  align-items: center;
  display: flex;
`;
